






















































import RevealPasswordField from '@/components/ui/RevealPasswordField.vue'
import { Usuario } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { UsuariosModule } from '@/store/vuex/usuario/UsuariosStore'
import { SaveUsuarioUseCase } from '@/usecases'
import { Component, Vue} from 'vue-property-decorator'

@Component({
	components: {
		RevealPasswordField,
	},
})
export default class DialogoDePrimeiroAcesso extends Vue {
	mostra = false
	usuario: Usuario | null = null
	senha: string | null = null
	login: string | null = null
	confirmacaoDeSenha: string | null = null
	errorMessages: { confirmacaoDeSenha: string[] } = {
		confirmacaoDeSenha: [],
	}
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	usuarioLogado = JSON.parse(localStorage.getItem('USUARIO_LOGADO')!)
	saveUsuarioUseCase = new SaveUsuarioUseCase()

	async salvar() {
		if (!this.usuario) return
		if (this.senha !== this.confirmacaoDeSenha) {
			this.errorMessages.confirmacaoDeSenha = ['As senhas não coincidem']
			return 
		}

		this.errorMessages.confirmacaoDeSenha = []

		try {
			const usuario: Usuario = {
				...this.usuario,
				senha: !this.confirmacaoDeSenha ? '' : this.confirmacaoDeSenha,
				isPrimeiroAcesso: false,
			}
			const usuarioSalvo = await this.saveUsuarioUseCase.save(usuario)
			UsuariosModule.atualizaUsuario(usuarioSalvo)

			AlertModule.setSuccess('Senha atualizada com sucesso!')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.mostra = false

		}
	}

	mostrar(){
		this.usuario = this.usuarioLogado
		if(!this.usuario) return

		this.mostra = this.usuario.isPrimeiroAcesso
		this.login = this.usuario.login
	}
}
